import { get as lodashGet } from "lodash-es";
import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

export const useGetMaintenanceMode = () => {
  const { data: config } = useInstanceConfigQuery();
  return {
    isMaintenanceModeEnabled: lodashGet(
      config,
      "configuration.is_maintenance_mode_enabled",
      false
    ),
    messageOnMaintenancePage: lodashGet(
      config,
      "configuration.message_on_maintenance_page",
      ""
    )
  };
};
